import { QUERY_PARAMS, ROUTES, PREDICT_PRODUCT_SLUG } from '@futrli/shared-services';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useFederatedSignIn } from './use-federated-sign-in';
import { UILoader } from '@futrli/ui-components';
import queryString from 'query-string';
import { FederatedIdentityProvider } from './types';
import { capitalize } from 'lodash';

/**
 * Automatic SSO trigger by url.
 */
export const FederatedSignInTrigger: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const { federatedSignInError, handleFederatedSignIn } = useFederatedSignIn();

  /**
   * Triggers the SSO flow as soon as the component is mounted.
   */
  useEffect(() => {
    const federatedSignInProvider = capitalize(queryParams[QUERY_PARAMS.PROVIDER] as string);

    if (!federatedSignInProvider) {
      throw new Error('Federated Sign In provider needs to be defined');
    }

    // Due to we don't know if the user is already registered or not in cognito at this point,
    // we will send the user through the register flow, if it is registered then the register flow
    // will be skipped.
    handleFederatedSignIn(federatedSignInProvider as FederatedIdentityProvider, {
      originLocationPathname: [ROUTES.REGISTER, PREDICT_PRODUCT_SLUG].join('/'),
      originLocationSearch: location.search
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Handles the federated sign in errors
   */
  useEffect(() => {
    if (!federatedSignInError) {
      return;
    }

    navigate(ROUTES.LOGIN);
  }, [federatedSignInError, navigate]);

  return <UILoader isFull={true} />;
};
